import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {setTriPos} from './setTriPos';

gsap.registerPlugin(ScrollTrigger);

export const para = (): void => {
  const paraBgs = document.querySelectorAll('.c-para-bg');
  const paraAnimConts = document.querySelectorAll('.c-anim-cont');
  paraBgs.forEach((paraBg) => {
    gsap.to(paraBg.querySelector('.c-para-bg__bg'), {
      top: '0%',
      scrollTrigger: {
        trigger: paraBg,
        start: 'top 100%',
        end: 'bottom 0%',
        scrub: true,
      },
    });
  });
  paraAnimConts.forEach((paraAnimCont) => {
    const tris = paraAnimCont.querySelectorAll('.c-anim-tri');
    tris.forEach((tri) => {
      const TriElm = tri as HTMLElement;
      const triInner = tri.querySelector('.c-anim-tri__inner') as HTMLElement;
      // console.log(TriElm.dataset.depth, TriElm.dataset.maxAngle);
      const depth = parseFloat(TriElm.dataset.depth || '-1');
      const maxAngle = parseFloat(TriElm.dataset.maxAngle || '45');
      const origAngle = parseFloat(TriElm.dataset.origAngle || '0');
      setTriPos(TriElm, triInner, depth, maxAngle, origAngle);
      setTimeout(() => {
        tri.classList.add('--ready');
      });
      window.addEventListener('scroll', () => {
        setTriPos(TriElm, triInner, depth, maxAngle, origAngle);
      });
      gsap.fromTo(
        tri,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.5,
          scrollTrigger: {
            trigger: tri,
            start: 'top 110%',
            toggleActions: 'play none none reverse',
          },
        }
      );
    });
  });
};
